'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _TypeEditor = require('./editors/TypeEditor');

var _TypeEditor2 = _interopRequireDefault(_TypeEditor);

var _types = require('./editors/types');

var _types2 = _interopRequireDefault(_types);

var _firekit4 = require('@upgrowth/firekit');

var _Loading = require('./Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _TypeContext = require('./editors/TypeContext');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FirelightView = function (_React$Component) {
  (0, _inherits3.default)(FirelightView, _React$Component);

  function FirelightView() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FirelightView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FirelightView.__proto__ || (0, _getPrototypeOf2.default)(FirelightView)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (path, update) {
      var publish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false; // console.log("Handling change", path, update, publish)

      var firelight = _this.props.firelight;
      var pathString = path.join('/');

      var _firekit = (0, _firekit4.firekit)(),
          database = _firekit.database;

      return database.ref(firelight + '/content/draft/' + pathString).set(update).then(function () {
        return publish && database.ref(firelight + '/content/current/' + pathString).set(update);
      } // .then(() => base.fetch(`${firelight}/content/current`, {context: this}))
      // .then((val) => this.addVersion(val))
      );
    }, _this.handleDelete = function (path) {
      var firelight = _this.props.firelight;
      var pathString = path.join('/');

      var _firekit2 = (0, _firekit4.firekit)(),
          database = _firekit2.database;

      return database.ref(firelight + '/content/draft/' + pathString).parent.set(null).then(function () {
        return database.ref(firelight + '/content/current/' + pathString).parent.set(null);
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FirelightView, [{
    key: 'addVersion',
    value: function addVersion(val) {
      var _firekit3 = (0, _firekit4.firekit)(),
          database = _firekit3.database,
          TIMESTAMP = _firekit3.TIMESTAMP,
          auth = _firekit3.auth;

      var firelight = this.props.firelight;
      var ref = database.ref(firelight + '/content/versionInfo/').update({
        timestamp: TIMESTAMP,
        userId: auth.currentUser.uid,
        user: auth.currentUser.email
      });
      return ref.then(function () {
        return database.ref(firelight + '/content/version/' + ref.key, val);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          view = _props.view,
          viewName = _props.viewName,
          current = _props.current,
          firelight = _props.firelight,
          draft = _props.draft,
          loading = _props.loading;

      if (loading) {
        return _react2.default.createElement(_Loading2.default, null);
      }

      var types = (0, _extends4.default)({}, _types2.default, this.props.types, (0, _defineProperty3.default)({}, viewName, view));
      var isDirty = !(0, _immutable.is)((0, _immutable.fromJS)(draft), (0, _immutable.fromJS)(current));
      var baseRoute = this.props.baseRoute || "";
      return _react2.default.createElement('div', {
        className: 'FirelightView'
      }, _react2.default.createElement(_TypeContext.TypesProvider, {
        types: types
      }, _react2.default.createElement(_TypeEditor2.default, {
        name: viewName,
        types: types,
        context: {
          path: [],
          labels: [],
          isClean: !isDirty,
          value: draft,
          current: current,
          onChange: this.handleChange,
          onDelete: this.handleDelete,
          // TODO - What are these in here for - better solved by a react context perhaps?
          firelight: firelight,
          snapshot: draft,
          routeTo: function routeTo(path) {
            return [baseRoute].concat((0, _toConsumableArray3.default)(path)).join('/');
          }
        }
      })));
    }
  }]);
  return FirelightView;
}(_react2.default.Component);

exports.default = (0, _firekit4.firebind)(FirelightView, {
  view: function view(_ref2) {
    var firelight = _ref2.firelight,
        viewName = _ref2.viewName;
    return firelight + '/views/' + viewName;
  },
  types: function types(_ref3) {
    var firelight = _ref3.firelight,
        viewName = _ref3.viewName;
    return firelight + '/types';
  },
  draft: function draft(_ref4) {
    var firelight = _ref4.firelight,
        viewName = _ref4.viewName;
    return firelight + '/content/draft';
  },
  current: function current(_ref5) {
    var firelight = _ref5.firelight,
        viewName = _ref5.viewName;
    return firelight + '/content/current';
  }
});